import React from 'react';
import {ColorUIChecker1, ColorUIChecker2, ColorUIChecker3, ColorWhite} from 'src/styles/Colors';
import AppText from "../commons/AppText";
import {logDebug} from "../../utils/AppLog";
import {cloneDeep} from "lodash";
import JackpotGameView, {SLOT_GAME_END_DELAY_MS} from "./JackpotGameView";
import {FontWeightMedium} from "../../../res/FontWeight";
import ImageBackground from "../commons/ImageBackground";
import View from "../commons/View";
import GameAudio from "../commons/GameAudio";
import {GAME_NEUTRAL_AUDIO} from "../../utils/GameAudioPlayer";

const GAME_END_DELAY_MS = 1.2 * 1000;

export default class GameGreedySpinView extends React.Component {

    constructor(props) {
        super(props);
        this.items = props.items;
        this.refSlots = {};

        this.state = {
            ideal: true,
        };
    }

    stop(stopData) {
        const endValues = stopData.endValues;
        for (let i = 0; i < this.props.rows; i++) {
            const cloneStopData = cloneDeep(stopData);
            cloneStopData.endValues = endValues[i];
            const ref = this.refSlots['refSlotView'+ i];
            ref.stop(cloneStopData);
        }
    }

    reset() {
        this.setState({ideal: true});

        for (let i = 0; i < this.props.rows; i++) {
            const ref = this.refSlots['refSlotView'+ i];
            if (ref) {
                ref.reset();
            }
        }
    }

    render() {
        const isLTR = this.props.isLTR;
        const uiConfigs = this.props.uiConfigs;
        const cardSize = this.getCardSize();
        const sizeFactor = uiConfigs.sizeFactor;
        const sizeVFactor = uiConfigs.sizeVFactor;
        const rows = this.props.rows;
        const hideSpin = this.props.hideSpin;
        const slotViews = [];
        for (let i = 0; i < this.props.rows; i++) {
            let hideSlotSpin = i < rows - 1;
            if (!hideSlotSpin) {
                hideSlotSpin = hideSpin;
            }
            slotViews.push(
                <View style={{marginTop: i > 0 ? 6 : 0}}>
                    <JackpotGameView
                        ref={(ref) => this.refSlots['refSlotView'+ i] = ref}
                        disableAudio={this.props.disableAudio || i < rows - 1}
                        noActionMode={this.props.noActionMode}
                        onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
                        mute={this.props.mute}
                        preview={i === 0 ? this.props.preview : false}
                        classes={this.props.classes}
                        contentWidth={this.props.width}
                        contentHeight={this.props.contentHeight}
                        uiConfigs={this.props.uiConfigs}
                        cardSize={cardSize}
                        items={this.props.items}
                        columns={this.props.columns}
                        rows={1}
                        gamePlayAudioUrl={this.props.gamePlayAudioUrl}
                        gameWinAudioUrl={this.props.gameWinAudioLocalUrl}
                        gameLoseAudioUrl={this.props.gameLoseAudioLocalUrl}
                        hideSpin={hideSlotSpin}
                        spinsLeft={this.props.spinsLeft}
                        spinsCount={this.props.spinsCount}
                        canSpin={this.props.canSpin}
                        onImageClicked={this.props.onImageClicked}
                        onSpinStarted={this.onSpinStarted.bind(this, i, rows)}
                        onSpinStopped={this.onSpinStopped.bind(this, i, rows)}
                    />
                </View>
            );
        }
        const spacing = 18;
        const bgBottomMargin = !hideSpin ? uiConfigs.spinViewHeight * sizeFactor + uiConfigs.spinButtonMarginTop * sizeVFactor : 0;
        return (
            <View>
                {!this.props.disableAudio ?
                  <div>
                      <GameAudio ref={(ref) => this.gamePlayAudioIdNeutral = ref} source={GAME_NEUTRAL_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                  </div>
                  : null
                }
                <View style={{width: 180 * sizeFactor, height: 60 * sizeFactor, alignSelf: 'center', justifyContent: 'center', marginBottom: 4}}>
                    <ImageBackground source={uiConfigs.collectionImage} resizeMode="fill" style={{position: 'absolute', left: 0, top: 0, bottom: 0, right: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}} >
                        <View style={{position: 'relative', alignItems: 'center', justifyContent: 'center', marginLeft: isLTR ? 62 * sizeFactor: 0, marginRight: isLTR ? 0 : 62 * sizeFactor, marginBottom: 4 * sizeFactor}}>
                            <AppText fontSizeN={uiConfigs.fontSize} variant={'h6'} style={{fontWeight: FontWeightMedium, color: ColorWhite}}>{this.props.collectedValue}</AppText>
                        </View>
                    </ImageBackground>
                </View>
                <View style={{justifyContent: 'center', flexDirection: 'row', margin: spacing, marginBottom: hideSpin ? spacing : 0, backgroundColor: ColorUIChecker3}}>
                    <View style={{alignItems: 'center'}}>
                        <ImageBackground source={uiConfigs.gameOuterBgImage} resizeMode="fill" style={{position: 'absolute', left: -spacing, top: -spacing, bottom: bgBottomMargin -spacing, right: -spacing, width: '100%', height: '100%'}} />
                        {slotViews}
                    </View>
                </View>
            </View>
        );
    }

    onSpinStarted = (i, rows) => {
        if (i === rows - 1) {
            for (let i = 0; i < this.props.rows - 1; i++) {
                const ref = this.refSlots['refSlotView'+ i];
                ref.start();
            }
            this.setState({ideal: false});
            if (this.props.onSpinStarted) {
                this.props.onSpinStarted();
            }
        }
    };

    onSpinStopped = (i, rows) => {
        if (i === rows - 1) {
            this.spinStopped();
        }
    };

    spinStopped() {
        const playNeutralAudio = () => {
            if (this.gamePlayAudioIdNeutral) {
                this.gamePlayAudioIdNeutral.play();
            }
        };

        playNeutralAudio();
        if (this.isSpinComplete) {
            playNeutralAudio();
        }
        // Vibration.vibrate(200);

        let delay = SLOT_GAME_END_DELAY_MS;
        if (this.isSpinComplete) {
            delay = GAME_END_DELAY_MS;
        }
        setTimeout(() => {
            this.setState({ideal: true});
            if (this.props.onSpinStopped) {
                this.props.onSpinStopped();
            }
        }, delay);
    }

    getCardSize() {
        const uiConfigs = this.props.uiConfigs;
        const sizeFactor = uiConfigs.sizeFactor;

        const rows = this.props.rows;
        const columns = this.props.columns;
        const borderWidth = 52 * sizeFactor + (columns - 1) * 6;
        const borderHeight = 52 * sizeFactor + (rows - 1) * 6;
        const otherUiHeight = 180 * sizeFactor;

        const possibleWidth = (this.props.contentWidth - borderWidth) / columns; // borderWidth
        const possibleHeight = (this.props.contentHeight - otherUiHeight - borderHeight) / rows; // borderWidth
        const possibleSize = Math.min(possibleWidth, possibleHeight);
        const cardSize = Math.floor(Math.min(200, possibleSize));
        return cardSize;
    }
}
